import DIYPage, { getStaticProps } from './page/[page]'

export const config = { unstable_JsPreload: false }

export default DIYPage

export { getStaticProps }
